import type { AvailabilityRangeModel } from '../Models/StudentModel';
import type {
  MonthListEntry,
  MonthlyReportModel,
  StudentProfileModel
} from '../Models/ReportModel';
import { http } from './httpService';

export const ReportService = {
  listMonths: () => http.get<{ months: MonthListEntry[] }>('/monthly-reports'),

  /**
   * A month that has closed comes back exactly as it was stored. A month still
   * running is built fresh each time and never frozen.
   */
  month: (month: string) => http.get<MonthlyReportModel>(`/monthly-reports/${month}`),

  studentProfile: (name: string) =>
    http.get<StudentProfileModel>(`/students/${encodeURIComponent(name)}/profile`),

  saveAvailability: (name: string, availability: AvailabilityRangeModel[]) =>
    http.put<{ availability: AvailabilityRangeModel[] }>(
      `/students/${encodeURIComponent(name)}/profile`,
      { availability }
    )
};
